import { render, staticRenderFns } from "./SoporteMobile.vue?vue&type=template&id=6dbe862c&"
import script from "./SoporteMobile.vue?vue&type=script&lang=ts&"
export * from "./SoporteMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports